import { Country } from '../country';
import type { BMSMTiersConfig, Tier } from './bmsm-types';

export const BMSM_TIERS_CONFIG: BMSMTiersConfig = {
  [Country.UnitedStates]: {
    registeredFirstOrder: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Australia]: {
    registeredFirstOrder: [
      { threshold: 55, discountPercent: 0, type: 'shipping' },
      { threshold: 90, discountPercent: 5, type: 'discount' },
      { threshold: 110, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 55, discountPercent: 0, type: 'shipping' },
      { threshold: 90, discountPercent: 5, type: 'discount' },
      { threshold: 110, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 55, discountPercent: 0, type: 'shipping' },
      { threshold: 110, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.NewZealand]: {
    registeredFirstOrder: [
      { threshold: 60, discountPercent: 0, type: 'shipping' },
      { threshold: 100, discountPercent: 5, type: 'discount' },
      { threshold: 125, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 60, discountPercent: 0, type: 'shipping' },
      { threshold: 100, discountPercent: 5, type: 'discount' },
      { threshold: 125, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 60, discountPercent: 0, type: 'shipping' },
      { threshold: 125, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Canada]: {
    registeredFirstOrder: [
      { threshold: 70, discountPercent: 0, type: 'shipping' },
      { threshold: 105, discountPercent: 5, type: 'discount' },
      { threshold: 125, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 70, discountPercent: 0, type: 'shipping' },
      { threshold: 105, discountPercent: 5, type: 'discount' },
      { threshold: 125, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 70, discountPercent: 0, type: 'shipping' },
      { threshold: 125, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.UnitedKingdom]: {
    registeredFirstOrder: [
      { threshold: 45, discountPercent: 0, type: 'shipping' },
      { threshold: 65, discountPercent: 5, type: 'discount' },
      { threshold: 75, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 45, discountPercent: 0, type: 'shipping' },
      { threshold: 65, discountPercent: 5, type: 'discount' },
      { threshold: 75, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 45, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Singapore]: {
    registeredFirstOrder: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 90, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 90, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 90, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Malaysia]: {
    registeredFirstOrder: [
      { threshold: 170, discountPercent: 0, type: 'shipping' },
      { threshold: 260, discountPercent: 5, type: 'discount' },
      { threshold: 310, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 170, discountPercent: 0, type: 'shipping' },
      { threshold: 260, discountPercent: 5, type: 'discount' },
      { threshold: 310, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 170, discountPercent: 0, type: 'shipping' },
      { threshold: 310, discountPercent: 10, type: 'discount' },
    ],
  },
  // [Country.UnitedArabEmirates]: {
  //   registeredFirstOrder: [
  //     { threshold: 180, discountPercent: 0, type: 'shipping' },
  //     { threshold: 279, discountPercent: 5, type: 'discount' },
  //     { threshold: 330, discountPercent: 10, type: 'discount' },
  //   ],
  //   registeredReturning: [
  //     { threshold: 180, discountPercent: 0, type: 'shipping' },
  //     { threshold: 279, discountPercent: 5, type: 'discount' },
  //     { threshold: 330, discountPercent: 10, type: 'discount' },
  //   ],
  //   guest: [
  //     { threshold: 180, discountPercent: 0, type: 'shipping' },
  //     { threshold: 330, discountPercent: 10, type: 'discount' },
  //   ],
  // },
  // [Country.SaudiArabia]: {
  //   registeredFirstOrder: [
  //     { threshold: 220, discountPercent: 0, type: 'shipping' },
  //     { threshold: 320, discountPercent: 5, type: 'discount' },
  //     { threshold: 370, discountPercent: 10, type: 'discount' },
  //   ],
  //   registeredReturning: [
  //     { threshold: 220, discountPercent: 0, type: 'shipping' },
  //     { threshold: 320, discountPercent: 5, type: 'discount' },
  //     { threshold: 370, discountPercent: 10, type: 'discount' },
  //   ],
  //   guest: [
  //     { threshold: 220, discountPercent: 0, type: 'shipping' },
  //     { threshold: 370, discountPercent: 10, type: 'discount' },
  //   ],
  // },
  // [Country.Qatar]: {
  //   registeredFirstOrder: [
  //     { threshold: 215, discountPercent: 0, type: 'shipping' },
  //     { threshold: 314, discountPercent: 5, type: 'discount' },
  //     { threshold: 365, discountPercent: 10, type: 'discount' },
  //   ],
  //   registeredReturning: [
  //     { threshold: 215, discountPercent: 0, type: 'shipping' },
  //     { threshold: 314, discountPercent: 5, type: 'discount' },
  //     { threshold: 365, discountPercent: 10, type: 'discount' },
  //   ],
  //   guest: [
  //     { threshold: 215, discountPercent: 0, type: 'shipping' },
  //     { threshold: 365, discountPercent: 10, type: 'discount' },
  //   ],
  // },
  [Country.Netherlands]: {
    registeredFirstOrder: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Belgium]: {
    registeredFirstOrder: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Germany]: {
    registeredFirstOrder: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.France]: {
    registeredFirstOrder: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 5, type: 'discount' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 50, discountPercent: 0, type: 'shipping' },
      { threshold: 85, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Poland]: {
    registeredFirstOrder: [
      { threshold: 230, discountPercent: 0, type: 'shipping' },
      { threshold: 330, discountPercent: 5, type: 'discount' },
      { threshold: 390, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 230, discountPercent: 0, type: 'shipping' },
      { threshold: 330, discountPercent: 5, type: 'discount' },
      { threshold: 390, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 230, discountPercent: 0, type: 'shipping' },
      { threshold: 390, discountPercent: 10, type: 'discount' },
    ],
  },
  // temporarily hide Turkey until we have a way to support it
  // [Country.Turkey]: {
  //   registeredFirstOrder: [
  //     { threshold: 4100, discountPercent: 0, type: 'shipping' },
  //     { threshold: 5500, discountPercent: 5, type: 'discount' },
  //     { threshold: 6200, discountPercent: 10, type: 'discount' },
  //   ],
  //   registeredReturning: [
  //     { threshold: 4100, discountPercent: 0, type: 'shipping' },
  //     { threshold: 5500, discountPercent: 5, type: 'discount' },
  //     { threshold: 6200, discountPercent: 10, type: 'discount' },
  //   ],
  //   guest: [
  //     { threshold: 4100, discountPercent: 0, type: 'shipping' },
  //     { threshold: 5500, discountPercent: 5, type: 'discount' },
  //     { threshold: 6200, discountPercent: 10, type: 'discount' },
  //   ],
  // },
  [Country.Kazakhstan]: {
    registeredFirstOrder: [
      { threshold: 46000, discountPercent: 0, type: 'shipping' },
      { threshold: 64000, discountPercent: 5, type: 'discount' },
      { threshold: 73000, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 46000, discountPercent: 0, type: 'shipping' },
      { threshold: 64000, discountPercent: 5, type: 'discount' },
      { threshold: 73000, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 46000, discountPercent: 0, type: 'shipping' },
      { threshold: 73000, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Mongolia]: {
    registeredFirstOrder: [
      { threshold: 220000, discountPercent: 0, type: 'shipping' },
      { threshold: 310000, discountPercent: 5, type: 'discount' },
      { threshold: 360000, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 220000, discountPercent: 0, type: 'shipping' },
      { threshold: 310000, discountPercent: 5, type: 'discount' },
      { threshold: 360000, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 220000, discountPercent: 0, type: 'shipping' },
      { threshold: 360000, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Azerbaijan]: {
    registeredFirstOrder: [
      { threshold: 140, discountPercent: 0, type: 'shipping' },
      { threshold: 200, discountPercent: 5, type: 'discount' },
      { threshold: 220, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 140, discountPercent: 0, type: 'shipping' },
      { threshold: 200, discountPercent: 5, type: 'discount' },
      { threshold: 220, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 140, discountPercent: 0, type: 'shipping' },
      { threshold: 220, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Switzerland]: {
    registeredFirstOrder: [
      { threshold: 40, discountPercent: 0, type: 'shipping' },
      { threshold: 65, discountPercent: 5, type: 'discount' },
      { threshold: 75, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 40, discountPercent: 0, type: 'shipping' },
      { threshold: 65, discountPercent: 5, type: 'discount' },
      { threshold: 75, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 40, discountPercent: 0, type: 'shipping' },
      { threshold: 75, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Denmark]: {
    registeredFirstOrder: [
      { threshold: 370, discountPercent: 0, type: 'shipping' },
      { threshold: 560, discountPercent: 5, type: 'discount' },
      { threshold: 670, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 370, discountPercent: 0, type: 'shipping' },
      { threshold: 560, discountPercent: 5, type: 'discount' },
      { threshold: 670, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 370, discountPercent: 0, type: 'shipping' },
      { threshold: 670, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Norway]: {
    registeredFirstOrder: [
      { threshold: 640, discountPercent: 0, type: 'shipping' },
      { threshold: 940, discountPercent: 5, type: 'discount' },
      { threshold: 1100, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 640, discountPercent: 0, type: 'shipping' },
      { threshold: 940, discountPercent: 5, type: 'discount' },
      { threshold: 1100, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 640, discountPercent: 0, type: 'shipping' },
      { threshold: 1100, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Japan]: {
    registeredFirstOrder: [
      { threshold: 6600, discountPercent: 0, type: 'shipping' },
      { threshold: 9500, discountPercent: 5, type: 'discount' },
      { threshold: 11100, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 6600, discountPercent: 0, type: 'shipping' },
      { threshold: 9500, discountPercent: 5, type: 'discount' },
      { threshold: 11100, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 6600, discountPercent: 0, type: 'shipping' },
      { threshold: 11100, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Mexico]: {
    registeredFirstOrder: [
      { threshold: 800, discountPercent: 0, type: 'shipping' },
      { threshold: 1400, discountPercent: 5, type: 'discount' },
      { threshold: 1700, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 800, discountPercent: 0, type: 'shipping' },
      { threshold: 1400, discountPercent: 5, type: 'discount' },
      { threshold: 1700, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 800, discountPercent: 0, type: 'shipping' },
      { threshold: 1700, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Chile]: {
    registeredFirstOrder: [
      { threshold: 54000, discountPercent: 0, type: 'shipping' },
      { threshold: 80000, discountPercent: 5, type: 'discount' },
      { threshold: 94000, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 54000, discountPercent: 0, type: 'shipping' },
      { threshold: 80000, discountPercent: 5, type: 'discount' },
      { threshold: 94000, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 54000, discountPercent: 0, type: 'shipping' },
      { threshold: 94000, discountPercent: 10, type: 'discount' },
    ],
  },
  [Country.Colombia]: {
    registeredFirstOrder: [
      { threshold: 166000, discountPercent: 0, type: 'shipping' },
      { threshold: 275000, discountPercent: 5, type: 'discount' },
      { threshold: 331000, discountPercent: 10, type: 'discount' },
    ],
    registeredReturning: [
      { threshold: 166000, discountPercent: 0, type: 'shipping' },
      { threshold: 275000, discountPercent: 5, type: 'discount' },
      { threshold: 331000, discountPercent: 10, type: 'discount' },
    ],
    guest: [
      { threshold: 166000, discountPercent: 0, type: 'shipping' },
      { threshold: 331000, discountPercent: 10, type: 'discount' },
    ],
  },
};

export function getTiersForUser(params: { country: Country; isAuthenticated: boolean; isFirstOrder: boolean }): Tier[] {
  const { country, isAuthenticated, isFirstOrder } = params;
  const config = BMSM_TIERS_CONFIG[country];

  if (!isAuthenticated) {
    return config.guest;
  }

  return isFirstOrder ? config.registeredFirstOrder : config.registeredReturning;
}

export function generateTierTitle(tier: Tier): string {
  if (tier.type === 'shipping') {
    return 'Free Shipping';
  }
  return `${tier.discountPercent}% OFF`;
}
